import { __read, __spread } from "tslib";
import { convertDate } from '@keen.io/time-utils';
import { KEEN_TABLE_INTERVAL } from '../../../constants';
export var tableChartTransformation = function (query, result, dateModifier) {
    var data = [];
    var keys = new Set();
    var tableValue = query.analysis_type + "." + query.event_collection;
    result.forEach(function (interval) {
        var _a;
        var _b = interval, value = _b.value, startDate = _b.timeframe.start;
        keys.add(tableValue);
        data.push((_a = {},
            _a[KEEN_TABLE_INTERVAL] = convertDate(startDate, dateModifier),
            _a[tableValue] = value,
            _a));
    });
    return {
        data: data,
        keys: __spread(keys),
    };
};
